import React, { FunctionComponent } from 'react'

import { VehicleKBA } from '../../../domain'
import { TExtends } from '../../../infrastructure/internationalisation'
import { VehicleCardKBA, VehicleLookupKBA } from '../../organisms/vehicle'
import { FormInputProps } from '../types'

export interface VehicleFormInputMetaKBA {
  profile?: string
}

export const VehicleLookupFormInputKBA: FunctionComponent<
  FormInputProps<VehicleKBA, VehicleFormInputMetaKBA>
> = ({ name, value, onChange, tKey, tName, meta }) =>
  value ? (
    <VehicleCardKBA value={value} onChange={onChange} />
  ) : (
    <VehicleLookupKBA
      name={name}
      onChange={onChange}
      tKey={TExtends(tKey, tName)}
      config={{
        profile: meta?.profile,
      }}
      value={value?.[0] ?? null}
    />
  )
